<template>
  <div>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <Table
        border
        ref="table"
        @on-row-click="rowClick"
        :loading="loading"
        highlight-row
        :columns="orgPositionColumns"
        :data="orgPositionData"
        width="100%"
        stripe
      >
      </Table>
      <Row style="margin-top:15px">
        <Col span="19">
          <Page
            :total="total"
            :page-size="pageInfo.pageSize"
            @on-change="pageChange"
          />
        </Col>
      </Row>
    </Card>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title">组织职位信息</p>
      <Form
        style="margin: 30px 20px"
        :model="formItem"
        :disabled="form_loading"
        inline
        :label-width="150"
        label-position="left"
      >
        <FormItem
          :label="lang == 'zh' ? chNameMap[val] : enNameMap[val]"
          v-for="(val, key) in sortfMap"
          :key="key"
          v-if="
            showSelfData[val] == '1' &&
              val != 'orgcode7' &&
              val != 'orgcode8' &&
              val != 'orgcode9' &&
              val != 'orgcode10'
          "
        >
          <Checkbox
            v-if="
              val == 'defaultposition' ||
                val == 'consistent' ||
                val == 'isassistant'
            "
            style="min-width: 260px;margin-right: 50px;"
            v-model="formItem[val]"
            :disabled="disableSelfData[val] == 0"
          ></Checkbox>
          <DatePicker
            v-else-if="
              val == 'positionstartdate' ||
                val == 'expiredate' ||
                val == 'gradeeffectivedate'
            "
            type="date"
            v-model="formItem[val]"
            style="min-width: 260px;margin-right: 50px;"
            :disabled="disableSelfData[val] == 0"
          ></DatePicker>
          <Select
            v-else-if="
              val == 'orgcode1' ||
                val == 'orgcode2' ||
                val == 'orgcode3' ||
                val == 'orgcode4' ||
                val == 'orgcode5' ||
                val == 'orgcode6'
            "
            :disabled="disableSelfData[val] == 0"
            :clearable="true"
            v-model="formItem[val]"
            style="min-width: 260px;margin-right: 50px;"
            @on-change="getOrgList(val, val + 'List')"
          >
            <Option
              v-for="item in orgcodeList[val + 'List']"
              :value="item.orgCode"
              :key="item.orgCode"
              :label="item.orgCname"
            ></Option>
          </Select>
          <Input
            v-else-if="val == 'positioncode'"
            v-model="formItem[val]"
            style="min-width: 260px;margin-right: 50px;"
            :disabled="disableSelfData[val] == 0"
            readonly
          >
            <Button
              slot="append"
              icon="ios-search"
              :disabled="disableSelfData[val] == 0"
              @click="positionCodeShow = true"
            ></Button>
          </Input>
          <Input
            v-else
            v-model="formItem[val]"
            style="min-width: 260px;margin-right: 50px;"
            :disabled="disableSelfData[val] == 0"
          />
        </FormItem>
        <div
          v-for="(val, key) in sortfMap"
          :key="key"
          v-if="
            showSelfData[val] == '1' &&
              (val == 'orgcode7' ||
                val == 'orgcode8' ||
                val == 'orgcode9' ||
                val == 'orgcode10')
          "
        >
          <FormItem :label="lang == 'zh' ? chNameMap[val] : enNameMap[val]">
            <Select
              :clearable="true"
              v-model="formItem[val]"
              style="min-width: 260px;margin-right: 50px;"
              :disabled="disableSelfData[val] == 0"
              @on-change="getOrgList(val, val + 'List')"
            >
              <Option
                v-for="item in orgcodeList[val + 'List']"
                :value="item.orgCode"
                :key="item.orgCode"
                :label="item.orgCname"
              ></Option>
            </Select>
          </FormItem>
        </div>
      </Form>
    </Card>
    <div class="bottomBtn">
      <Button type="primary" v-if="!form_loading" @click="saveData()"
        >保存</Button
      >
      <Button v-if="plan" @click="returnPage()" style="margin-left: 15px"
        >返回</Button
      >
    </div>

    <PositionCode
      :positionCodeShow="positionCodeShow"
      @posCodeItem="posCodeItem"
      @posCodecancle="posCodecancle"
    ></PositionCode>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../../../src/util/DateUtil";
import PositionCode from "./PositionCode";
import watermark from "@/util/watermark";

export default {
  components: { PositionCode },
  data() {
    return {
      date: new DateUtil(),
      orgPositionData: [],
      form_loading: true,
      chNameMap: {},
      enNameMap: {},
      userIdL: "",
      loading: false,
      plan: "",
      id: null,
      pageInfo: {
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      formItem: {},
      evaluationType: [],
      disableSelfData: {},
      showSelfData: {},
      chNameMap: {},
      enNameMap: {},
      orgcodeList: {
        orgcode1List: [],
        orgcode2List: [],
        orgcode3List: [],
        orgcode4List: [],
        orgcode5List: [],
        orgcode6List: [],
        orgcode7List: [],
        orgcode8List: [],
        orgcode9List: [],
        orgcode10List: []
      },

      orgList: [],
      orgForm: {},
      positionCodeShow: false,
      sortfMap: {}
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    getWaterMarkStatus() {
      return this.$store.getters.getWaterMarkStatus == 1
        ? watermark.addWaterMark()
        : "";
    },
    orgPositionColumns() {
      let column = [
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.positionstartdate
              : this.enNameMap.positionstartdate,
          key: "positionstartdate",
          align: "center",
          minWidth: 180,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.positionstartdate, "YYYY-MM-DD")
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.expiredate
              : this.enNameMap.expiredate,
          key: "expiredate",
          align: "center",
          minWidth: 180,
          render: (h, params) => {
            return h(
              "span",
              params.row.expiredate > "9999-12-30"
                ? ""
                : this.date.dateVal(params.row.expiredate, "YYYY-MM-DD")
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.positioncode
              : this.enNameMap.positioncode,
          key: "positioncode",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.defaultposition
              : this.enNameMap.defaultposition,
          key: "defaultposition",
          align: "center",
          minWidth: 180,
          render: (h, params) => {
            return h("span", params.row.defaultposition == "0" ? "否" : "是");
          }
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.eTitle : this.enNameMap.eTitle,
          key: "positionEname",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.cTitle : this.enNameMap.cTitle,
          key: "positionCname",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.dirsuper
              : this.enNameMap.dirsuper,
          key: "dirsuper",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.dirsuperpos
              : this.enNameMap.dirsuperpos,
          key: "dirsuperpos",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.indirsuper
              : this.enNameMap.indirsuper,
          key: "indirsuper",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.indirsuperpos
              : this.enNameMap.indirsuperpos,
          key: "indirsuperpos",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.grade : this.enNameMap.grade,
          key: "grade",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.gradeeffectivedate
              : this.enNameMap.gradeeffectivedate,
          key: "gradeeffectivedate",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.gradeeffectivedate, "YYYY-MM-DD")
            );
          },
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.isassistant
              : this.enNameMap.isassistant,
          key: "isassistant",
          align: "center",
          minWidth: 180,
          render: (h, params) => {
            return h("span", params.row.isassistant == "0" ? "否" : "是");
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.consistent
              : this.enNameMap.consistent,
          key: "consistent",
          align: "center",
          minWidth: 180,
          render: (h, params) => {
            return h("span", params.row.consistent == "0" ? "否" : "是");
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.headcountper
              : this.enNameMap.headcountper,
          key: "headcountper",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.jobdescription
              : this.enNameMap.jobdescription,
          ellipsis: true,
          key: "jobdescription",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Tooltip",
                {
                  props: { placement: "top" }
                },
                [
                  h(
                    "span",
                    {
                      style: {
                        display: "inline-block",
                        width: params.column._width * 0.9 + "px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                      }
                    },
                    params.row.jobdescription
                  ),
                  h(
                    "span",
                    {
                      slot: "content",
                      style: { whiteSpace: "normal", wordBreak: "break-all" }
                    },
                    params.row.jobdescription
                  )
                ]
              )
            ]);
          },
          minWidth: 260
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.orgcode1
              : this.enNameMap.orgcode1,
          key: "orgcode1",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.orgcode2
              : this.enNameMap.orgcode2,
          key: "orgcode2",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.orgcode3
              : this.enNameMap.orgcode3,
          key: "orgcode3",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.orgcode4
              : this.enNameMap.orgcode4,
          key: "orgcode4",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.orgcode5
              : this.enNameMap.orgcode5,
          key: "orgcode5",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.orgcode6
              : this.enNameMap.orgcode6,
          key: "orgcode6",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.orgcode7
              : this.enNameMap.orgcode7,
          key: "orgcode7",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.orgcode8
              : this.enNameMap.orgcode8,
          key: "orgcode8",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.orgcode9
              : this.enNameMap.orgcode9,
          key: "orgcode9",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.orgcode10
              : this.enNameMap.orgcode10,
          key: "orgcode10",
          align: "center",
          minWidth: 180
        }
      ];
      let arr = [];
      arr = column.filter(item => {
        return this.showSelfData[item.key] == 1;
      });
      return arr;
    }
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
    // this.getOrgList()
  },
  methods: {
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getTableData();
    },
    getData(id, plan) {
      (this.plan = plan ? plan : ""), (this.id = id);
      this.getTableData();
    },
    getOrgList(item, listname) {
      let nowIndex = item.slice(-1);
      let obj = {};
      for (var i = 1; i <= nowIndex; i++) {
        eval(`obj.${"orgcode" + i} = this.formItem.${"orgcode" + i}`);
      }
      for (let i in this.orgForm) {
        if (!Object.getOwnPropertyDescriptor(item, i)) {
          this.formItem[i] = "";
        }
      }
      axios.post("/OrgPosition/selectOrgSelectionInfo", obj).then(res => {
        if (res) {
          if (item) {
            this.orgcodeList[listname] = res;
            this.$set(this.orgcodeList, Object.keys(listname), res);
          } else {
            this.orgObject.orgcode1List = res;
          }
        }
      });
    },
    rowClick(row, index) {
      this.form_loading =
        this.disableSelfData.OrgPosition == "0" ? true : false;
      this.formItem = JSON.parse(JSON.stringify(row));
      this.formItem.defaultposition = !!+this.formItem.defaultposition;
      this.formItem.isassistant = !!+this.formItem.isassistant;
      this.formItem.consistent = !!+this.formItem.consistent;
      const {
        orgcode1List,
        orgcode2List,
        orgcode3List,
        orgcode4List,
        orgcode5List,
        orgcode6List,
        orgcode7List,
        orgcode8List,
        orgcode9List,
        orgcode10List
      } = row;
      const {
        orgcode1,
        orgcode2,
        orgcode3,
        orgcode4,
        orgcode5,
        orgcode6,
        orgcode7,
        orgcode8,
        orgcode9,
        orgcode10
      } = row;
      this.orgcodeList = {
        orgcode1List,
        orgcode2List,
        orgcode3List,
        orgcode4List,
        orgcode5List,
        orgcode6List,
        orgcode7List,
        orgcode8List,
        orgcode9List,
        orgcode10List
      };
      this.orgForm = {
        orgcode1,
        orgcode2,
        orgcode3,
        orgcode4,
        orgcode5,
        orgcode6,
        orgcode7,
        orgcode8,
        orgcode9,
        orgcode10
      };
      // console.log(this.orgcodeList)
      // this.getOrgList(this.formItem)
    },
    getTableData(item) {
      this.loading = true;
      let Obj = {
        serialnumber: this.plan ? this.plan : this.userId,
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        sheetId: this.id,
        bePersonal: this.plan ? "0" : "1"
      };
      axios.post("/OrgPosition/selectOrgPositionInfo", Obj).then(res => {
        this.loading = false;
        if (res) {
          this.chNameMap = res.chNameMap;
          this.enNameMap = res.enNameMap;
          this.orgPositionData = res.data;
          this.showSelfData = res.showSelfData;
          this.sortfMap = res.sortfMap;
          delete this.sortfMap[3];
          this.total = parseInt(res.pageInfo.total);
          this.disableSelfData = res.disableSelfData;
        }
      });
    },
    returnPage() {
      this.$router.back();
    },
    saveData() {
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "",
        onOk: () => {
          let saveItem = JSON.parse(JSON.stringify(this.formItem));
          saveItem.defaultposition =
            this.formItem.defaultposition &&
            this.formItem.defaultposition == true
              ? 1
              : 0;
          saveItem.isassistant =
            this.formItem.isassistant && this.formItem.isassistant == true
              ? 1
              : 0;
          saveItem.consistent =
            this.formItem.consistent && this.formItem.consistent == true
              ? 1
              : 0;
          let obj = {
            serialnumber: this.plan,
            ...saveItem
          };
          this.modal_loading = true;
          axios
            .post("/OrgPosition/updateOrgPositionInfo", obj)
            .then(res => {
              this.modal_loading = false;
              if (res) {
                this.$Message.info(res);
                this.getTableData();
              }
            })
            .catch(err => {
              this.$Message.info(err);
            });
        },
        onCancel: () => {}
      });
    },
    posCodeItem(item) {
      console.log(item);
      this.positionCodeShow = false;
      this.formItem.positioncode = item.positioncode;
    },
    posCodecancle() {
      this.positionCodeShow = false;
    }
  }
};
</script>
<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
  /* margin-right: 30px; */
}
.formColT {
  width: calc(((100% - 210px) / 3) * 2);
  float: left;
  /* margin-right: 30px; */
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc((100% - 40px) / 2);
  }
  .formColT {
    width: calc((100% - 40px) / 2);
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
  .formColT {
    width: 100%;
  }
}
.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.ivu-date-picker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/components/OrgPosition.vue